import React, { Component } from 'react';
import NumberFormat from 'react-number-format';
import Slider from 'react-rangeslider';
import DatePicker from 'react-date-picker';
import FeatherIcon from 'feather-icons-react';
import { connect } from 'react-redux';
import { Switch } from '@material-ui/core';

// To include the default styles
import 'react-rangeslider/lib/index.css'
import DebitCard from '../payment/DebitCard';
import GetApi from '../../api_request/Get';
import { ServerLink, RedirectLink } from '../../keys/Links';
import notifyError from '../../inc/SnackbarError';
import postApi from '../../api_request/Post';
import { Spinner } from 'react-bootstrap';


class AddSavings extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            setMonths: 6,
            amount: 200000,
            title: '',
            purpose: '',
            startDate: '',
            autosave: '',
            autosaveAmount: Math.ceil(200000 / 6 / 1),
            authorization_id: 'new',
            dueDate: '',
            period: 'Monthly',
            step: 1,
            cards: [],
            isLoading: true,
            isLocked: false,
            autosaveEnabled: true,

        }
    }


    componentDidMount() {

        //get the Card
        GetApi(ServerLink + '/cards').then(
            res => {
                //console.log(res)

                if (res.status == true) {

                    this.setState({
                        cards: res.cards,
                        isLoading: false
                    })
                }
                else {

                    notifyError(res.error, 'error', 'top-center')


                    this.setState({
                        isLoading: false
                    })
                }
            }
        ).catch(e => {
            console.log(e)

            notifyError('Oops.. Something went wrong, check your internet connection', 'error', 'top-center')
            this.setState({
                isLoading: false
            })
        })

    }


    handleOnChange = (value) => {
        this.setState({
            setMonths: value,
        })
    }

    handlePeriodChange = (period) => {
        const autosaveAmount = Math.ceil(this.state.amount / this.state.setMonths / (period === 'Monthly' ? 1 : period === 'Weekly' ? 4 : 28));
        this.setState({
            period: period,
            autosaveAmount: autosaveAmount,
            autosave: `${autosaveAmount}-${period}`
        });
    }

    handleDateChange = (e) => {

        e.preventDefault();

        let sDate = document.getElementById('startDate').value;

        this.setState({
            startDate: sDate,


        })


        //console.log(date)

    }


    addMonths = (date, months) => {

        //get the day of the month
        var d = date.getDate();

        date.setMonth(date.getMonth() + +months);

        if (date.getDate() != d) {
            date.setDate(0);
        }


        return date;
    }

    calculateEndDate = () => {
        const today = new Date();
        const endDate = new Date(today.getFullYear(), today.getMonth() + this.state.setMonths, today.getDate());
        return endDate.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
    }


    handleInput = (i) => {
        i.preventDefault();
        const name = i.target.name;
        const value = i.target.value;
        this.setState({ [name]: value });

        //console.log(value)
    }

    handleSubmit = (e) => {

        e.preventDefault();


        if (this.state.step === 1) {

            if (this.state.title == "" || this.state.amount == "" || this.state.period == "") {
                notifyError('Please fill all the form fields as appropriate', 'error', 'top-right');
            }
            else {
                this.setState({
                    step: 2
                })

                if (this.state.period === 'Daily') {
                    this.setState({
                        startDate: '12:00'
                    });
                }
                else if (this.state.period === 'Weekly') {
                    this.setState({
                        startDate: 'Sunday'
                    });
                }
            }
        }


        if (this.state.step === 2) {
            if (this.state.startDate == "") {
                notifyError('Please fill all the form fields as appropriate', 'error', 'top-right');
            } else {
                this.setState({ isLoading: true });
                const data = {
                    'title': this.state.title,
                    'purpose': this.state.purpose,
                    'target_amount': this.state.amount,
                    'timeline_goal': this.state.setMonths,
                    'charge_amount': this.state.autosaveAmount,
                    'charge_period': this.state.period,
                    'start_date': this.state.startDate,
                    'autosave': this.state.autosaveEnabled ? true : false,
                    'is_locked': this.state.isLocked ? true : false,
                }


                //console.log(data);

                postApi(ServerLink + '/payment/create_savings', data).then(

                    res => {
                        if (res.status == true) {

                            notifyError(res.message, 'success', 'top-right')

                            this.setState({
                                isLoading: false
                            })

                            setTimeout(() => {
                                //window.location.replace(RedirectLink+'/#/history');
                                window.location.reload();
                            }, 5000);
                        }
                        else {

                            notifyError(res.message, 'error', 'top-right')

                            this.setState({
                                isLoading: false
                            })

                            setTimeout(() => {
                                //window.location.replace(RedirectLink+'/#/history');
                                //window.location.reload();
                            }, 6000);
                        }

                        console.log(res);
                    }
                ).catch(e => {

                    notifyError(e.message, 'error', 'top-right');

                    this.setState({
                        isLoading: false
                    })

                    console.log(e)

                })
            }
        }

    }



    currentStep = e => {

        const { setMonths } = this.state;

        if (this.state.step === 1) {

            return (
                <form onSubmit={this.handleSubmit}>
                    <div className="bg-gradient-to-r from-green-500 to-teal-500 rounded-2xl shadow-lg p-6 text-white mb-8">
                        <div className="flex items-center gap-2 mb-3">
                            <FeatherIcon icon="target" size={28} />
                            <h2 className="text-2xl font-bold workSanBold">Create New Savings Target</h2>
                        </div>
                        <p className="text-green-100 workSanMedium text-sm">Set up an automated savings plan with smart features</p>
                    </div>

                    <div className="space-y-6">
                        <div>
                            <label className="block text-sm font-semibold text-gray-700 workSanBold mb-2">Savings Title</label>
                            <input 
                                name="title" 
                                value={this.state.title} 
                                onChange={this.handleInput} 
                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 workSanMedium" 
                                type="text" 
                                placeholder="e.g., School Fees, Emergency Fund" 
                            />
                        </div>




                        <div>
                            <label className="block text-sm font-semibold text-gray-700 workSanBold mb-2">Target Amount</label>
                            <div className="flex items-center gap-3">
                                <div className="bg-gray-100 px-4 py-3 rounded-lg font-bold text-gray-700 workSanBold text-lg">
                                    {this.props.userInfo.currency_symbol}
                                </div>
                                <NumberFormat
                                    thousandSeparator={true}
                                    displayType='input'
                                    className="flex-1 px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 text-lg font-semibold"
                                    value={this.state.amount}
                                    placeholder="Enter amount"
                                    onValueChange={(values) => {
                                        const { value } = values;
                                        this.setState({ amount: value });
                                    }}
                                />
                            </div>
                        </div>


                        <div>
                            <div className="flex items-center justify-between mb-3">
                                <label className="block text-sm font-semibold text-gray-700 workSanBold">Timeline</label>
                                <span className="text-2xl font-bold text-green-600 workSanBold">{setMonths} months</span>
                            </div>
                            <Slider
                                value={setMonths}
                                orientation="horizontal"
                                onChange={this.handleOnChange}
                                max={36}
                                min={3}
                                step={1}
                                className=""
                            />
                            <div className="flex justify-between text-xs text-gray-500 mt-2 workSanMedium">
                                <span>3 months</span>
                                <span>36 months</span>
                            </div>
                        </div>




                        <div>
                            <label className="block text-sm font-semibold text-gray-700 workSanBold mb-4">Savings Frequency</label>
                            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                                {[
                                    { period: 'Monthly', divisor: 1, color: 'from-blue-500 to-blue-600', icon: 'calendar' },
                                    { period: 'Weekly', divisor: 4, color: 'from-green-500 to-green-600', icon: 'repeat' },
                                    { period: 'Daily', divisor: 28, color: 'from-purple-500 to-purple-600', icon: 'clock' }
                                ].map(({ period, divisor, color, icon }) => {
                                    const amount = Math.ceil(this.state.amount / this.state.setMonths / divisor);
                                    const isSelected = this.state.period === period;
                                    return (
                                        <button
                                            key={period}
                                            type="button"
                                            onClick={() => this.handlePeriodChange(period)}
                                            className={`p-4 rounded-xl border-2 transition-all duration-300 ${
                                                isSelected
                                                    ? `bg-gradient-to-br ${color} text-white border-transparent shadow-lg`
                                                    : 'bg-white border-gray-200 text-gray-700 hover:border-green-300'
                                            }`}
                                        >
                                            <div className="flex items-center gap-2 mb-2">
                                                <FeatherIcon icon={icon} size={18} />
                                                <span className="font-bold workSanBold text-sm">{period}</span>
                                            </div>
                                            <p className={`font-bold text-lg workSanBold ${ isSelected ? 'text-white' : 'text-green-600' }`}>
                                                <NumberFormat thousandSeparator={true} displayType="text" prefix={this.props.userInfo.currency_symbol} value={amount} />
                                            </p>
                                            <p className={`text-xs workSanMedium ${ isSelected ? 'text-green-100' : 'text-gray-500' }`}>
                                                per {period.toLowerCase()}
                                            </p>
                                        </button>
                                    );
                                })}
                            </div>
                        </div>



                    <div className="" hidden>
                        <label className="workSanBold">Savings End Date</label>
                        <input name="end" className="py-3 px-2 border w-full bg-gray-200" defaultValue={this.state.dueDate} readOnly />
                    </div>




                        <div>
                            <label className="block text-sm font-semibold text-gray-700 workSanBold mb-2">Purpose (Optional)</label>
                            <textarea 
                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 resize-none" 
                                name="purpose" 
                                onChange={this.handleInput}
                                value={this.state.purpose}
                                rows="3"
                                placeholder="Why are you saving? E.g., Emergency fund, vacation, etc."
                            />
                        </div>

                        <div className="space-y-4 p-4 bg-green-50 rounded-xl border border-green-200">
                            <div className="flex items-center justify-between">
                                <div className="flex items-center gap-3">
                                    <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
                                        <FeatherIcon icon="zap" size={18} className="text-green-600" />
                                    </div>
                                    <div>
                                        <p className="font-bold text-gray-800 workSanBold text-sm">Auto-Save Enabled</p>
                                        <p className="text-xs text-gray-600 workSanMedium">Automatically deduct savings from your account</p>
                                    </div>
                                </div>
                                <Switch 
                                    checked={this.state.autosaveEnabled}
                                    onChange={(e) => this.setState({ autosaveEnabled: e.target.checked })}
                                    color="primary"
                                />
                            </div>
                        </div>

                        <div className="space-y-4 p-4 bg-red-50 rounded-xl border border-red-200">
                            <div className="flex items-center justify-between">
                                <div className="flex items-center gap-3">
                                    <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center">
                                        <FeatherIcon icon="lock" size={18} className="text-red-600" />
                                    </div>
                                    <div>
                                        <p className="font-bold text-gray-800 workSanBold text-sm">Lock Savings</p>
                                        <p className="text-xs text-gray-600 workSanMedium">Prevent modifications once savings starts</p>
                                    </div>
                                </div>
                                <Switch 
                                    checked={this.state.isLocked}
                                    onChange={(e) => this.setState({ isLocked: e.target.checked })}
                                    color="primary"
                                />
                            </div>
                        </div>
                    </div>


                        <button 
                            type="submit"
                            className="w-full py-3 mt-6 bg-gradient-to-r from-green-500 to-teal-500 text-white font-bold workSanBold rounded-lg hover:shadow-lg transition-all duration-300 flex items-center justify-center gap-2"
                        >
                            Review & Continue
                            <FeatherIcon icon="arrow-right" size={18} />
                        </button>

                </form>
            )
        }

        if (this.state.step === 2) {
            return (

                <div className="">
                    <button 
                        type="button"
                        className="flex items-center gap-2 text-green-600 hover:text-green-700 font-semibold workSanBold mb-6 transition" 
                        onClick={() => this.setState({ step: 1 })}
                    >
                        <FeatherIcon icon="arrow-left" size={18} />
                        Go Back
                    </button>

                    <div className="bg-gradient-to-r from-green-500 to-teal-500 rounded-2xl shadow-lg p-6 text-white mb-6">
                        <h2 className="text-2xl font-bold workSanBold flex items-center gap-2">
                            <FeatherIcon icon="check-circle" size={28} />
                            Review Your Savings Plan
                        </h2>
                        <p className="text-green-100 workSanMedium mt-1">Confirm the details before creating your savings target</p>
                    </div>
                    <div className="">

                        <div>
                            <form onSubmit={this.handleSubmit}>

                                {/* <div className="mt-5 mb-2">
                        <label className="workSanMedium">Add Credit Card</label>
                        <select className="px-2 py-3 border w-full" name="authorization_id" onChange={this.handleInput}>
                            <option value="new">New Card</option>
                            {
                                this.state.cards.map((card, index)=> (
                                <option value={card.authorization_id}> *** {card.last4} </option>
                            ))}
                        </select>

                        {
                            this.state.authorization_id =='new' ?
                    
                        <div className="bg-red-100 p-3 mt-3">
                            <p className="workSanMedium">Note: For adding a New Card, ₦1,000 will be charged and added to your Smart Purse</p>
                        </div>
                        :
                        null
                        }
                    </div> */}



                                <div className="space-y-4">

                                    <div className="bg-green-50 rounded-lg p-4 border border-green-200">
                                        <p className="text-xs text-green-700 workSanBold uppercase mb-1">Savings Title</p>
                                        <h3 className="text-xl font-bold text-gray-900 workSanBold">{this.state.title || 'Untitled'}</h3>
                                    </div>

                                    <div className="grid grid-cols-2 gap-4">
                                        <div className="bg-blue-50 rounded-lg p-4 border border-blue-200">
                                            <p className="text-xs text-blue-700 workSanBold uppercase mb-1">Target Amount</p>
                                            <h3 className="text-lg font-bold text-blue-900 workSanBold">
                                                <NumberFormat displayType="text" thousandSeparator={true} prefix={this.props.userInfo.currency_symbol} value={this.state.amount} />
                                            </h3>
                                        </div>
                                        <div className="bg-purple-50 rounded-lg p-4 border border-purple-200">
                                            <p className="text-xs text-purple-700 workSanBold uppercase mb-1">Timeline</p>
                                            <h3 className="text-lg font-bold text-purple-900 workSanBold">{this.state.setMonths} months</h3>
                                        </div>
                                    </div>

                                    <div className="bg-indigo-50 rounded-lg p-4 border border-indigo-200">
                                        <p className="text-xs text-indigo-700 workSanBold uppercase mb-1">Expected End Date</p>
                                        <h3 className="text-lg font-bold text-indigo-900 workSanBold">{this.calculateEndDate()}</h3>
                                    </div>

                                    <div className="bg-orange-50 rounded-lg p-4 border border-orange-200">
                                        <p className="text-xs text-orange-700 workSanBold uppercase mb-1">{this.state.period} Savings Amount</p>
                                        <h3 className="text-2xl font-bold text-orange-900 workSanBold">
                                            <NumberFormat displayType="text" thousandSeparator={true} prefix={this.props.userInfo.currency_symbol} value={this.state.autosaveAmount} />
                                        </h3>
                                        <p className="text-xs text-orange-600 mt-1 workSanMedium">Charged {this.state.period.toLowerCase()}</p>
                                    </div>

                                    {/* 
                        <div className="mt-3">
                            <label> Charges and VAT:</label>
                            <h5 className="f-w-700">
                                <NumberFormat className="bg-none" displayType="text" thousandSeparator={true} prefix="₦" value={this.state.autosaveAmount*0.014+500} />
                            </h5>
                        </div> */}

                                    {/* <div className="mt-3">
                            <label> Total Charges:</label>
                            <h5 className="f-w-700">
                                <NumberFormat className="bg-none" displayType="text" thousandSeparator={true} prefix="₦" value={this.state.autosaveAmount*0.014+200+parseInt(this.state.autosaveAmount)} />
                            </h5>
                        </div> */}






                                    {this.state.purpose && (
                                        <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                                            <p className="text-xs text-gray-700 workSanBold uppercase mb-1">Purpose</p>
                                            <p className="text-gray-900 workSanMedium">{this.state.purpose}</p>
                                        </div>
                                    )}

                                    <div className="grid grid-cols-2 gap-4">
                                        <div className="bg-teal-50 rounded-lg p-4 border border-teal-200">
                                            <p className="text-xs text-teal-700 workSanBold uppercase mb-1 flex items-center gap-1">
                                                <FeatherIcon icon="zap" size={12} />
                                                Auto-Save
                                            </p>
                                            <h3 className="text-lg font-bold text-teal-900 workSanBold">{this.state.autosaveEnabled ? 'Enabled' : 'Disabled'}</h3>
                                        </div>
                                        <div className="bg-red-50 rounded-lg p-4 border border-red-200">
                                            <p className="text-xs text-red-700 workSanBold uppercase mb-1 flex items-center gap-1">
                                                <FeatherIcon icon="lock" size={12} />
                                                Locked
                                            </p>
                                            <h3 className="text-lg font-bold text-red-900 workSanBold">{this.state.isLocked ? 'Yes' : 'No'}</h3>
                                        </div>
                                    </div>



                                    <div>
                                        {
                                            this.state.period == 'Monthly'
                                                ?
                                                <>
                                                    <label className="workSanBold">Select Savings Day of the {this.state.period} </label>
                                                    <input type="date" id="startDate" defaultValue={this.state.startDate} className="px-2 py-3 w-full border mb-3" onChange={this.handleDateChange} />
                                                </>
                                                :
                                                this.state.period == 'Weekly'

                                                    ?
                                                    <>
                                                        <label className="workSanBold text-blue-700">Select the {this.state.period} Saving Day  </label>
                                                        <select id="startDate" className="px-2 py-3 w-full border mb-3" onChange={this.handleDateChange}>
                                                            <option value="Sunday">Sunday</option>
                                                            <option value="Monday">Monday</option>
                                                            <option value="Tuesday">Tuesday</option>
                                                            <option value="Wednessday">Wednessday</option>
                                                            <option value="Thursday">Thursday</option>
                                                            <option value="Friday">Friday</option>
                                                            <option value="Saturday">Saturday</option>
                                                        </select>
                                                    </>

                                                    :
                                                    <>
                                                        <label className="workSanBold">The {this.state.period} Saving Time  </label>
                                                        <input type="time" id="startDate" defaultValue={this.state.startDate} className="px-2 py-3 w-full border mb-3" onChange={this.handleDateChange} readOnly />
                                                    </>
                                        }



                                    </div>

                                </div>



<div className="mt-8">
                                        {this.state.isLoading ? (
                                            <button type="button" disabled className="w-full py-3 bg-green-300 text-white font-bold workSanBold rounded-lg flex items-center justify-center gap-2">
                                                <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="mr-1" />
                                                Creating your savings plan...
                                            </button>
                                        ) : (
                                            <button 
                                                type="submit" 
                                                className="w-full py-3 bg-gradient-to-r from-green-500 to-teal-500 text-white font-bold workSanBold rounded-lg hover:shadow-lg transition-all duration-300 flex items-center justify-center gap-2"
                                            >
                                                <FeatherIcon icon="check" size={18} />
                                                Confirm & Create Savings
                                            </button>
                                        )}
                                    </div>

                            </form>

                        </div>
                    </div>

                </div>

            );
        }
    }



    render() {
        let { setMonths } = this.state
        return (
            <div>
                {this.currentStep()}

            </div>
        )
    }
}


const mapStateToProps = state => {

    return {
        userInfo: state.auth.user
    }
}



export default connect(mapStateToProps, '')(AddSavings);




//export default